import { Paper } from "@mui/material";
import { AutoAwesomeMotion, Collections as CollectionsIcon, Storage } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { FormattedMessage } from "react-intl";

import { NodeEnv } from "@dzambalaorg/constants";
import { List } from "@dzambalaorg/ui-kit";

const data = [
  { text: "pages.collection.contracts", link: "/collection/contracts", icon: <CollectionsIcon /> },
  { text: "pages.collection.templates", link: "/collection/templates", icon: <AutoAwesomeMotion /> },
  { text: "pages.collection.tokens", link: "/collection/tokens", icon: <Storage /> },
];

export const CollectionSection = () => {
  const isProd = process.env.NODE_ENV === NodeEnv.production;

  if (isProd) {
    return null;
  }

  return (
    <Paper sx={{ mb: 2 }}>
      <List
        component="nav"
        subheader={
          <List.Subheader>
            <FormattedMessage id="pages.dashboard.mechanics.collection" />
          </List.Subheader>
        }
      >
        {data.map(({ text, icon, link }) => (
          <List.ItemButton<typeof RouterLink> key={text} component={RouterLink} to={link}>
            <List.ItemIcon>{icon}</List.ItemIcon>
            <List.ItemText>
              <FormattedMessage id={text} />
            </List.ItemText>
          </List.ItemButton>
        ))}
      </List>
    </Paper>
  );
};
